<template>
  <a-tabs
      v-model:activeKey="searchForm.status"
      style="background-color: #fff; padding: 0 12px"
      @change="getTableData()"
  >
    <a-tab-pane key="0" tab="全部"></a-tab-pane>
    <a-tab-pane key="1" tab="待开票"></a-tab-pane>
    <a-tab-pane key="2" tab="已开票"></a-tab-pane>
    <a-tab-pane key="3" tab="不开票"></a-tab-pane>
  </a-tabs>

  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one">
            <a-input
                v-model:value="searchForm.order_id"
                :loading="searchLoading"
                allowClear
                placeholder="订单ID"
                @search="getTableData"
            ></a-input>
          </div>
          <div class="group-one">
            <a-input
                v-model:value="searchForm.hid"
                :loading="searchLoading"
                allowClear
                placeholder="房间ID"
                @search="getTableData"
            ></a-input>
          </div>
          <div class="group-one">
            <a-input
                v-model:value="searchForm.email"
                :loading="searchLoading"
                allowClear
                placeholder="邮箱"
                @search="getTableData"
            ></a-input>
          </div>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.keyword"
              :loading="searchLoading"
              placeholder="订单号/抬头/税号"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 12 ? 2500 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_no'">
          <a-button
              type="link"
              @click="
              detShow = true;
              orderId = record.order_id;
            "
          >{{ record.order_no }}
          </a-button
          >
        </template>
        <template v-if="column.key == 'invoice_info'">
          <div v-if="record.type == 1">
            <div>{{ record.companyName }}</div>
            <div>{{ record.companyCode }}</div>
            <div>{{ record.companyAdress }}</div>
            <div>{{ record.companyBank }}</div>
            <div>{{ record.companyBankaccount }}</div>
            <div>{{ record.email }}</div>

          </div>
          <div v-else>
            <div>{{ record.personName }}</div>
            <div>{{ record.email }}</div>
          </div>
        </template>
        <template v-if="column.key == 'user_id'">
          <div>{{ record.user_id }}</div>
          <div>{{ record.nickname }}</div>
        </template>
        <template v-if="column.key == 'op_user_id'">
          <div>{{ record.op_user_id }}</div>
          <div>{{ record.uunickname }}</div>
        </template>
        <template v-if="column.key == 'create_time'">
          <div>{{ record.create_time }}</div>
          <div v-if="record.invoice_time">{{ record.invoice_time_text }}</div>
        </template>
        <template v-if="column.key == 'url'">
          <a-image-preview-group v-if="record.url" class="image-preview-group">
            <a-image :src="record.url" :width="45"/>
          </a-image-preview-group>
        </template>
        <template v-if="column.key == 'status_text'">
          <span v-if="record.status == 1" class="f-c-red">{{ record.status_text }}</span>
          <span v-else>{{ record.status_text }}</span>
        </template>
        <template v-if="column.key == 'operate'">
          <a-button v-if="record.status == 1"
                    type="link"
                    @click="handleEdit(record)"
          >去开票
          </a-button
          >
          <a-button v-if="record.status == 1"
                    type="link"
                    @click="handleUnOpen(record)"
          >不开票
          </a-button
          >
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination
        :pageTotal="pageTotal"
        @onShowSizeChange="onShowSizeChange"
        @pageChange="pageChange"
    />

    <!-- 订单详情 -->
    <order-details
        v-model:visible="detShow"
        :orderId="orderId"
        @refreshOrderDetails="refresh"
    />
    <!-- 弹窗-开票 -->
    <a-modal
        v-model:visible="showOpen"
        :title="modalTitle"
        :width="600"
        @ok="addSave"
    >
      <a-form
          ref="formRef"
          :label-col="{ span: 4 }"
          :model="addForm"
          :rules="rules"
          hideRequiredMark
          labelAlign="left"
      >

        <a-form-item v-if="addForm.opType == 2" class="f-item" label="营业执照图片" name="special_fire_cert">
          <div class="image">
            <a-upload
                :action="action"
                :data="formData"
                :headers="header"
                :show-upload-list="false"
                class="avatar-uploader"
                list-type="picture-card"
                name="image"
                @change="
                  ($event) => {
                    uploadFinally($event, 'url');
                  }
                "
            >
              <img
                  v-if="addForm.url"
                  :src="addForm.url"
                  alt="图片"
                  fit="fill"
                  style="
                    width: 80px;
                    height: 80px;
                    object-fit: cover;
                    cursor: pointer;
                  "
              />
              <div v-else>
                <div class="ant-upload-text f-c-999">上传图片</div>
              </div>
            </a-upload>
          </div>
        </a-form-item>
        <a-form-item label="备注说明：" name="remark">
          <a-textarea
              v-model:value="addForm.remark"
              :maxlength="255"
              placeholder="请输入处理备注信息" show-count
              style="width: 100%"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";
import {nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {invoiceList, invoiceOperate,} from "@/api/api";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index";
import {message} from "ant-design-vue";
import { baseRequestUrl } from "../../../../config.js";

export default {
  components: {
    OrderDetails,
  },
  setup() {
    let {countTable} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        status: 0,
        keyword: "",
        start: 0,
        limit: 20,
        order_id: "",
        hid: "",
        email: "",
      },
      rangePicker: [],
      visiblePopover: false,
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      handleReset() {
        search.searchForm.order_id = '';
        search.searchForm.keyword = "";
        search.searchForm.user_id = "";
        search.searchForm.hid = "";
        table.getTableData();
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    function getColumns() {
      return [
        {
          title: "记录ID",
          dataIndex: "id",
          key: "id",
          isShow: true,
          width: 80,
        },
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          min_width: 120,
          isShow: true,
        },
        {
          title: "用户信息",
          dataIndex: "user_id",
          key: "user_id",
          isShow: true,
          width: 150,
          ellipsis: true
        },
        {
          title: "类型",
          dataIndex: "type_text",
          key: "type_text",
          width: 80,
          isShow: true,
        },
        {
          title: "开票信息",
          dataIndex: "invoice_info",
          key: "invoice_info",
          min_width: 400,
          isShow: true
        },
        {
          title: "附件",
          dataIndex: "url",
          key: "url",
          width: 100,
          isShow: true,
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
          min_width: 80,
          isShow: true,
          ellipsis: true,
        },
        {
          title: "操作信息",
          dataIndex: "op_user_id",
          key: "op_user_id",
          width: 150,
          isShow: true,
          ellipsis: true,
        },
        {
          title: "备注说明",
          dataIndex: "remark",
          key: "remark",
          width: 150,
          isShow: true,
          ellipsis: true,
        },
        {
          title: "申请/处理时间",
          dataIndex: "create_time",
          key: "create_time",
          width: 150,
          isShow: true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
        },
      ];
    }

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      currentItem: {},
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        invoiceList(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              nextTick(() => {
                table.columns = getColumns();
                table.initColumns = getColumns();
              });
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      columns: [
        {
          title: "记录ID",
          dataIndex: "id",
          key: "id",
          isShow: true,
          width: 80,
        },
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          min_width: 120,
          isShow: true,
        },
        {
          title: "用户信息",
          dataIndex: "user_id",
          key: "user_id",
          isShow: true,
          width: 150,
          ellipsis: true
        },
        {
          title: "类型",
          dataIndex: "type_text",
          key: "type_text",
          width: 80,
          isShow: true,
        },
        {
          title: "开票信息",
          dataIndex: "invoice_info",
          key: "invoice_info",
          min_width: 400,
          isShow: true
        },
        {
          title: "附件",
          dataIndex: "url",
          key: "url",
          width: 100,
          isShow: true,
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
          min_width: 80,
          isShow: true,
          ellipsis: true,
        },
        {
          title: "操作信息",
          dataIndex: "op_user_id",
          key: "op_user_id",
          width: 150,
          isShow: true,
          ellipsis: true,
        },
        {
          title: "备注说明",
          dataIndex: "remark",
          key: "remark",
          width: 150,
          isShow: true,
          ellipsis: true,
        },
        {
          title: "申请/处理时间",
          dataIndex: "create_time",
          key: "create_time",
          width: 150,
          isShow: true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
        },
      ],
      handleEdit(item) {
        console.log(item)
        modal.modalTitle = "开票";
        nextTick(() => {
          modal.addForm.opType = 2;
          modal.addForm.id = item.id;
        });
        modal.showOpen = true;
      },
      handleUnOpen(item) {
        console.log(item)
        modal.modalTitle = "开票说明";
        nextTick(() => {
          modal.addForm.opType = 3;
          modal.addForm.id = item.id;
        });
        modal.showOpen = true;
      },
    });
    // 弹窗
    const modal = reactive({
      modalTitle: "",
      showOpen: false,
      uploadLoading: false,
      formRef: "", //表单验证
      addForm: {
        url: "",
        remark: "",
        id: "",
        opType: "",
      },
      action:
          baseRequestUrl + "/h5/upload/uploadImg" +
          "?info=" +
          JSON.parse(sessionStorage.getItem("landlordInfo")).info,
      header: {
        token: JSON.parse(sessionStorage.getItem("landlordInfo")).token,
        version: "1.0.0",
        source: "1",
      },
      formData: {
        module: "pms",
        type: "invoice",
      },
      rules: {
        url: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
      },
      // 保存
      isLoading: false,
      addSave() {
        if (modal.isLoading) {
          return;
        }
        invoiceOperate(modal.addForm)
            .then((res) => {
              message.success(res.msg);
              nextTick(() => {
                modal.isLoading = false;
              });
              modal.showOpen = false;
              table.getTableData();
            })
            .catch(() => {
              modal.isLoading = false;
            });
      },
      //  上传图片
      uploadFinally(info, key) {
        if (info.file.status === "done") {
          modal.addForm[key] = info.file.response.data.url;
        }
      },
    });

    // 订单
    const order = reactive({
      detShow: false,
      orderId: "",
      refresh() {
        table.getTableData();
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 115;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 115;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
      ...toRefs(modal),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.image-preview-group {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview-group img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
</style>
